const ObjectIcon = ({
  color = "currentColor",
  ...rest
}: {
  color?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 25 25"
      {...rest}
    >
      <g clip-path="url(#a)">
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M2.325 7.403v-2.54a2.54 2.54 0 0 1 2.54-2.539h2.538M2.325 17.56v2.539a2.54 2.54 0 0 0 2.54 2.539h2.538M17.56 2.324h2.54a2.54 2.54 0 0 1 2.539 2.54v2.539M17.56 22.638h2.54a2.54 2.54 0 0 0 2.539-2.54V17.56M12.86 6.821l5.366 3.019v6.037l-5.366 3.019-5.367-3.019V9.84l5.367-3.02Zm0 6.039 5.366-3.02"
        />
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.342"
          d="M12.86 12.859v5.578"
        />
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M12.86 12.86 7.493 9.84"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h24.963v24.963H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ObjectIcon;
